import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Lock from '@material-ui/icons/Lock';
import Avatar from '@material-ui/core/Avatar';
import Tooltip from '@material-ui/core/Tooltip';
import Skeleton from 'react-loading-skeleton';
import { Mutation } from 'react-apollo';
import { RoleBuilder } from '@iris-platform/protektor';
import gql from 'graphql-tag';
import { components as commonComponents } from '@555platform/portal-components/lib/client';
import {
  dissoc,
  without,
} from 'ramda';
import { GET_ALL_ROLES } from './RolesContainer';
import { PROTEKTOR_DELETE, PROTEKTOR_UPDATE, PROTEKTOR_CREATE } from '../../../utils/protektorConstants';

const REMOVE_ROLE = gql`
mutation($roleIdentifier:InputRoleIdentifier!) {
  removeRole(roleIdentifier:$roleIdentifier) {
    roleIdentifier {
      name
      displayName
      team
    }
    permissions {
      action
      resource
      allowed
    }
  }
}
`;

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 400,
    borderSpacing: '0px 7px',
    marginBottom: '2em',
  },
  heading: {
    backgroundColor: '#2b9cd8',
    fontSize: '24px',
    fontWeight: '500',
    lineHeight: '60px',
  },
  headContent: {
    color: '#fff',
    lineHeight: '41px',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'left',
    position: 'relative',
    textDecoration: 'none',
    borderBottom: 'none',
  },
  content: {
    lineHeight: '41px',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'left',
    position: 'relative',
    textDecoration: 'none',
    borderBottom: 'none',
  },
  contentEnd: {
    lineHeight: '41px',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'right',
    position: 'relative',
    textDecoration: 'none',
    borderBottom: 'none',
  },
  title: {
    color: '#1682bc',
    paddingLeft: '45px',
    fontSize: '24px',
  },
  OddRow: {
    backgroundColor: '#f6f6f6',
    marginLeft: '5px',
  },
  button: {
    backgroundColor: '#1eb368',
    padding: '5px 10px',
    borderRadius: '3px',
    border: '0px',
    color: '#fff',
    width: 76,
    height: 25,
    fontSize: 13,
  },
  gradientButton: {
    marginTop: '1rem',
    fontSize: '14px',
  },
  link: {
    paddingTop: '15px',
  },
});

const withoutTypename = dissoc('__typename');

const updateCache = (cache, role) => {
  const { allRoles } = cache.readQuery({ query: GET_ALL_ROLES });
  cache.writeQuery({
    query: GET_ALL_ROLES,
    data: { allRoles: without([role], allRoles) },
  });
};

class ListRoles extends Component {
  renderLoading = ({ classes, title }) => (
    <commonComponents.Panel
      title={title}
      avatar={(
        <Avatar>
          <Lock />
        </Avatar>
)}
    >
      <Table className={classes.table}>
        <TableHead>
          <TableRow className={classes.heading}>
            <TableCell className={classes.headContent}>Role Name</TableCell>
            <TableCell className={classes.headContent}>Type</TableCell>
            <TableCell className={classes.headContent}>Id</TableCell>
            <TableCell className={classes.headContent} />
          </TableRow>
        </TableHead>
        <TableBody>
          {Array(10).fill(null).map((val, i) => (
            <TableRow key={i}>
              <TableCell><Skeleton /></TableCell>
              <TableCell><Skeleton /></TableCell>
              <TableCell><Skeleton /></TableCell>
              <TableCell><Skeleton /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </commonComponents.Panel>
  );

  render() {
    const {
      classes, roles, title, isLoading, roleProp,
    } = this.props;

    if (isLoading) {
      return this.renderLoading(this.props);
    }

    const permRole = RoleBuilder.fromJSON(roleProp);

    return (
      <Mutation
        mutation={REMOVE_ROLE}
      >
        {(removeRole, error, loading) => (
          <commonComponents.Panel
            id="platformRolesPanel"
            title={title}
            avatar={(
              <Avatar>
                <Lock />
              </Avatar>
)}
          >
            <Table className={classes.table}>
              <TableHead>
                <TableRow className={classes.heading}>
                  <TableCell className={classes.headContent}>Role Name</TableCell>
                  <TableCell className={classes.headContent}>Type</TableCell>
                  <TableCell className={classes.headContent}>Id</TableCell>
                  <TableCell className={classes.headContent} />
                </TableRow>
              </TableHead>
              <TableBody>
                {roles.map((role, idx) => (
                  <TableRow
                    key={role.roleIdentifier.name}
                    className={idx % 2 === 1 ? classes.OddRow : ''}
                  >
                    <TableCell className={classes.content}>
                      {role.roleIdentifier.displayName}
                    </TableCell>
                    <TableCell className={classes.content}>
                      {role.roleIdentifier.team}
                    </TableCell>
                    <TableCell className={classes.content}>
                      {role.roleIdentifier.name}
                    </TableCell>
                    <TableCell className={classes.contentEnd}>
                      <Tooltip
                        id="tooltip-top-start"
                        title="Edit"
                        placement="top"
                      >
                        {(permRole.hasPermission({ action: PROTEKTOR_UPDATE, resource: 'Team_Roles' }) ? (
                          <Link
                            to={`/dashboard/teamroles/${role.roleIdentifier.name}/${role.roleIdentifier.team}/edit`}
                            className={classes.link}
                          >
                            <IconButton
                              aria-label="Edit"
                            >
                              <EditIcon />
                            </IconButton>
                          </Link>
                        ) : (
                          <IconButton
                            aria-label="Edit"
                            disabled
                          >
                            <EditIcon />
                          </IconButton>
                        ))}

                      </Tooltip>
                      <Tooltip
                        id="tooltip-top-start"
                        title="Delete"
                        placement="top"
                      >
                        <div>
                          <IconButton
                            aria-label="Close"
                            disabled={loading || !permRole.hasPermission({ action: PROTEKTOR_DELETE, resource: 'Team_Roles' })}
                            onClick={() => {
                              removeRole(
                                {
                                  variables: {
                                    roleIdentifier: withoutTypename(role.roleIdentifier),
                                  },
                                },
                              ).then(() => this.props.refetch());
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </div>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Button
              variant="contained"
              color="primary"
              className={classes.gradientButton}
              onClick={() => this.props.history.push(`${this.props.match.url}/create`)
              }
              disabled={!permRole.hasPermission({ action: PROTEKTOR_CREATE, resource: 'Team_Roles' })}
            >
              New Role
            </Button>
          </commonComponents.Panel>
        )}
      </Mutation>

    );
  }
}

ListRoles.propTypes = {
  classes: PropTypes.object.isRequired,
  roles: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ListRoles);
